import {Component, ContentChildren, ElementRef, HostListener, OnInit, QueryList} from '@angular/core';
import {TdoMdiItemComponent} from './tdo-mdi-item/tdo-mdi-item.component';
import {TdoMdiBoundsModel} from './models/tdo-mdi-bounds.model';

@Component({
  selector: 'tdo-mdi-manager',
  templateUrl: './tdo-mdi-manager.component.html',
  styleUrls: ['./tdo-mdi-manager.component.scss']
})
export class TdoMdiManagerComponent implements OnInit {
  @ContentChildren(TdoMdiItemComponent) items: QueryList<TdoMdiItemComponent>;

  itemsArray: TdoMdiItemComponent[] = [];
  bounds: DOMRect;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setOriginalBounds(TdoMdiBoundsModel.SOFT_RESET_TYPE);
  }

  constructor(public elRef: ElementRef) {
  }
  lastIndex = 1;

  ngOnInit(): void {
    console.log('TDO MDI MANAGER OnInit');
    const ivl = setInterval(() => {
      if (this.items && this.items.length > 0) {
        clearInterval(ivl);
        this.onItemsChanged();
        this.items.changes.subscribe(() => {
          this.onItemsChanged();
          this.resetItems();
        });
      }
    }, 100);
  }

  onItemsChanged() {
    this.bounds = this.elRef.nativeElement.getBoundingClientRect();
    // this.setOriginalBounds();
    this.itemsArray = this.items.toArray();
    for (const item of this.items) {
      item.parentContainer = this.elRef.nativeElement;
      let idx = this.itemsArray.findIndex(p => p === item);
      this.lastIndex = idx;
      item.elRef.nativeElement.style.position = 'relative';
      item.elRef.nativeElement.style.zIndex = idx;
      item.tdoMdiItemSelected.subscribe((val) => {
        item.elRef.nativeElement.style.zIndex = this.lastIndex++;
      });
    }
    // this.setItemsEqual();
  }

  setOriginalBounds(resetType = '') {
    let i = 0;
    this.bounds = this.elRef.nativeElement.getBoundingClientRect();
    for (const item of this.items) {
      const len = this.items.length;
      const width = this.bounds.width / len;
      const bnds = new TdoMdiBoundsModel();
      bnds.width = width;
      bnds.left = bnds.width * i++;
      bnds.top = 0;
      bnds.height = 500;
      item.setOriginalBounds(bnds, resetType);
    }
  }

  resetItems() {
    let i = 0;
    for (const item of this.items) {
      /*const len = this.items.length;
      const width = this.bounds.width / len;
      const bnds = new TdoMdiBoundsModel();
      bnds.width = width;
      bnds.left = bnds.width * i++;
      item.setOriginalBounds(bnds);*/
      item.reset();
    }
  }

  setItemsEqual() {
    if (this.items.length === 2) {
      const item0: TdoMdiItemComponent = this.items.get(0);
      const item1: TdoMdiItemComponent = this.items.get(1);
      const bnds = new TdoMdiBoundsModel();
      const width = this.bounds.width;
      bnds.height = (this.bounds.height * 0.75) - 20;

      let leftItem: TdoMdiItemComponent;
      let rightItem: TdoMdiItemComponent;
      if (item0.originalLeft < item1.originalLeft) {
        leftItem = item0;
        rightItem = item1;
      } else {
        leftItem = item1;
        rightItem = item0;
      }

      bnds.top = 20;
      bnds.width = (width * 0.5) - 20;
      bnds.left = 20;
      leftItem.setOriginalBounds(bnds, TdoMdiBoundsModel.HARD_RESET_TYPE);
      bnds.width = (width * 0.5) - 20;
      bnds.left = (width * 0.5) + 20;
      rightItem.setOriginalBounds(bnds, TdoMdiBoundsModel.HARD_RESET_TYPE);
    }
  }

  setEmphasizeLeft() {
    if (this.items.length === 2) {
      const item0: TdoMdiItemComponent = this.items.get(0);
      const item1: TdoMdiItemComponent = this.items.get(1);
      const bnds = new TdoMdiBoundsModel();
      const width = this.bounds.width;
      bnds.height = this.bounds.height * 0.75;

      let leftItem: TdoMdiItemComponent;
      let rightItem: TdoMdiItemComponent;
      if (item0.originalLeft < item1.originalLeft) {
        leftItem = item0;
        rightItem = item1;
      } else {
        leftItem = item1;
        rightItem = item0;
      }

      bnds.width = width * 0.75;
      bnds.left = 0;
      leftItem.setOriginalBounds(bnds, TdoMdiBoundsModel.HARD_RESET_TYPE);
      bnds.width = width * 0.25;
      bnds.left = width * 0.75;
      rightItem.setOriginalBounds(bnds, TdoMdiBoundsModel.HARD_RESET_TYPE);
    }
  }

  setEmphasizeRight() {
    if (this.items.length === 2) {
      const item0: TdoMdiItemComponent = this.items.get(0);
      const item1: TdoMdiItemComponent = this.items.get(1);
      const bnds = new TdoMdiBoundsModel();
      const width = this.bounds.width;
      bnds.height = this.bounds.height * 0.75;

      let leftItem: TdoMdiItemComponent;
      let rightItem: TdoMdiItemComponent;
      if (item0.originalLeft < item1.originalLeft) {
        leftItem = item0;
        rightItem = item1;
      } else {
        leftItem = item1;
        rightItem = item0;
      }

      bnds.width = width * 0.75;
      bnds.left = width * 0.25;
      rightItem.setOriginalBounds(bnds, TdoMdiBoundsModel.HARD_RESET_TYPE);
      bnds.width = width * 0.25;
      bnds.left = 0;
      leftItem.setOriginalBounds(bnds, TdoMdiBoundsModel.HARD_RESET_TYPE);
    }
  }

  onResetClick(event: MouseEvent) {
    this.setOriginalBounds(TdoMdiBoundsModel.HARD_RESET_TYPE);
  }

  setCascade() {
    this.itemsArray = this.items.toArray();

    let i = 0;
    for (const item of this.items) {
      const bounds = new TdoMdiBoundsModel();
      bounds.left = i * 20;
      bounds.top = i * 20;
      bounds.width = item.originalWidth;
      bounds.height = item.originalHeight;
      item.zIndex = bounds.left + 10;
      item.elRef.nativeElement.style.zIndex = i + 1;
      i++;
      item.setOriginalBounds(bounds, TdoMdiBoundsModel.HARD_RESET_TYPE);
    }
  }

  setTile(maxAcross: number = 4) {
    this.itemsArray = this.items.toArray();
    let maxPerRow = maxAcross;
    // let maxPerRow = 4;
    if (this.itemsArray.length < 5 && maxAcross === 4) {
      maxPerRow = this.itemsArray.length;
    }
    else {
      maxPerRow = maxAcross;
    }
    // const maxPerRow = 5;
    const margin = 50;
    const parentBounds = this.elRef.nativeElement.getBoundingClientRect();
    const size = (parentBounds.width / maxPerRow) - margin;

    let i = 0;
    let col = 0;
    let row = 0;
    for (const item of this.items) {
      if (col >= maxPerRow) {
        row++;
        col = 0;
      }
      const bounds = new TdoMdiBoundsModel();
      bounds.left = (col++ * (size + margin));
      bounds.top = (row * (size + margin));
      bounds.width = size;
      bounds.height = size;
      item.zIndex = bounds.left + 10;
      item.elRef.nativeElement.style.zIndex = i + 1;
      i++;
      item.setOriginalBounds(bounds, TdoMdiBoundsModel.HARD_RESET_TYPE);
    }
  }

  maximizeItems() {
   const ivl = setInterval(() => {
      if (this.items && this.items.length > 0) {
        const bounds = new TdoMdiBoundsModel();
        bounds.top = 0;
        bounds.left = 0;
        bounds.width = this.bounds.width;
        bounds.height = this.bounds.height;
        clearInterval(ivl);
        this.items.get(0).toggleMaximize();
      }
    }, 100);
  }
}
